module.exports = __webpack_public_path__ + "img/keyboard_Arrow_Left.4392b952.png";